import {Presenter} from './Presenter'

export const Create = () => {
  return <Presenter />
}
